// extracted by mini-css-extract-plugin
export default {"btn":"TagButton-styles-module--btn--uALQ1","active":"TagButton-styles-module--active--qIzGF"};